<template>
  <client-only>
    <div
      class="articles-nav ma-0 py-md-0"
      :class="[isSticky ? 'sticky' : 'static']"
    >
      <div class="articles-wrapper">
        <v-layout class="articles-wrapper-nav display-18" justify-space-between>
          <v-flex
            text-center
            v-for="(tab, index) in navItems"
            :key="tab.id"
            class="tab-item"
            :class="{ pipe: navItems.length - index != 1 }"
          >
            <v-btn
              :class="{ 'active-tab': isSelected(tab.name) }"
              class="pa-0"
              text
              @click="scrollToElement(tab.id)"
            >
              {{ tab.name }}
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </client-only>
</template>

<script>
import size from 'lodash/size';

export default {
  props: {
    navItems: {
     type: Array,
      required: false,
      default: () => []
    },
  },
  data() {
    return {
      scrollPosition: null,
      offset: 0,
    };
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateScroll);
  },
  mounted() {
    this.tabs;
    window.addEventListener('scroll', this.updateScroll);
  },

  computed: {
    isSticky() {
      return this.scrollPosition > 500;
    },
  },

  methods: {
    isSelected(tabName) {
      try {
        return decodeURIComponent(this.$route.hash.substring(1)).includes(
          tabName
        );
      } catch (error) {
        console.log('AnchorsNav isSelected', error);
        return false;
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    navigateToSection(selection) {
      let temp = selection.Link;

      this.$router.push({ path: this.$route.path, hash: temp });
    },

    notLastElement(object, index) {
      return size(object) - 1 != index ? true : false;
    },

    scrollToElement(selector) {
      const selectorPrefix = 'category-';
      if (process.client) {
        var position = findPos(
          document.getElementsByClassName(selectorPrefix + selector)
        );
        var offset = this.GetOffset();

        window.scroll(0, position - offset);
      }
    },

    GetOffset() {
      let offset;
      if (this.$vuetify.breakpoint.mdAndUp) {
        offset = 70;
      } else {
        offset = 25;
      }

      return offset;
    },
  },
};

function findPos(obj) {
  var curtop = 0;
  for (var i = 0; i < obj.length; i++) {
    var element = obj[i];
    if (element.offsetParent) {
      do {
        curtop += element.offsetTop;
      } while ((element = element.offsetParent));

      return curtop;
    }
  }

  return 0;
}
</script>

<style lang="scss" scoped>
.articles-nav {
  background-color: $bg-gray;
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 0px !important;
}

.articles-wrapper {
  margin: 0 auto;
  overflow-x: auto;
  overflow-y: hidden;
}

.articles-wrapper-nav {
  margin: 0 auto;
  white-space: nowrap;
}

.tab-item {
  display: inline-block;
  padding: 0 10px;
}

.pipe {
  position: relative;
}
.pipe:after {
  content: '|';
  position: absolute;
  left: -4px;
  top: 24%;
}
.active-tab {
  font-weight: 400;
  border-bottom: 4px solid #ff7100;
  margin-top: 2px;
}
.static {
  position: static;
}
.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  border-bottom: 1px solid #000;
  z-index: 10;
}

@media only screen and (min-width: 600px) {
  .pipe:after {
    content: '|';
    position: absolute;
    top: 7%;
  }
}
@media only screen and (min-width: 768px) {
  .articles-wrapper {
    width: 120vw;
  }
}

@media only screen and (min-width: 1024px) {
  .articles-wrapper {
    width: 1260px;
    margin: 0 auto;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .pipe:after {
    content: '|';
    position: absolute;
    top: 12%;
  }
}
</style>
